import { render, staticRenderFns } from "./BecomeAVendorTwo.vue?vue&type=template&id=f2b91b70"
import script from "./BecomeAVendorTwo.vue?vue&type=script&lang=js"
export * from "./BecomeAVendorTwo.vue?vue&type=script&lang=js"
import style0 from "./BecomeAVendorTwo.vue?vue&type=style&index=0&id=f2b91b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports